import React, {Component} from 'react';
import {Modal, ModalHeader} from 'reactstrap';
import {FaIcon} from "../FaIcon";
import {EditAgencyManagerLimitForm} from "./EditAgencyManagerLimitForm";

export class EditAgencyManagerLimitModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            modal: false
        };

        this.toggle = this.toggle.bind(this);
        this.handleFormSubmitted = this.handleFormSubmitted.bind(this);
    }

    toggle() {
        this.setState({
            modal: !this.state.modal
        });
    }

    handleFormSubmitted(agencyManagerLimitConfiguration) {
        this.toggle();
        this.props.onAgencyManagerLimitModified(agencyManagerLimitConfiguration);
    }

    render() {
        return (
            <span>
                <button className="edit-button" onClick={this.toggle}><FaIcon iconName={"pencil-alt"}/></button>
                <Modal isOpen={this.state.modal} toggle={this.toggle} className={this.props.className}>
                    <ModalHeader toggle={this.toggle}>Editar tope del MCC {this.props.managerId}</ModalHeader>
                    <EditAgencyManagerLimitForm closeModal={this.toggle}
                                                onModified={this.handleFormSubmitted}
                                                agencyManagerLimitConfigurationId={this.props.agencyManagerLimitConfigurationId}
                                                adSpentLimitAllTime={this.props.adSpentLimitAllTime}
                                                pauseAllCampaignsOnLimitExceededAllTime={this.props.pauseAllCampaignsOnLimitExceededAllTime}
                                                adSpentLimitTodayAtTimezone={this.props.adSpentLimitTodayAtTimezone}
                                                pauseAllCampaignsOnLimitExceededTodayAtTimezone={this.props.pauseAllCampaignsOnLimitExceededTodayAtTimezone}
                                                timezoneForTodayLimit={this.props.timezoneForTodayLimit}
                    />
                </Modal>
            </span>
        );
    }
}
